import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import FrontendNavbar from "components/navbar/FrontendNavbar";
import FooterFrontend from "components/footer/FooterFrontend";
import routes from "routes.js";

export default function Customer(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Europ Assistance");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Europ Assistance";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/customer") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <div className="h-full w-full bg-lightPrimary dark:bg-navy-900">
        <main className={`h-full flex-none transition-all`}>
          {/* Routes */}
          <div className="h-full">
            <FrontendNavbar />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh]">
              <Routes>
                {getRoutes(routes)}
                <Route path="/" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <FooterFrontend />
          </div>
        </main>
      </div>
    </div>
  );
}
